import { View } from 'foundations-components/components/View';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
export function FullPageLoader() {
  return /*#__PURE__*/_jsx(View, {
    position: "relative",
    blockSize: "100%",
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true,
      layout: "centered"
    })
  });
}